/**
 * lhx-fbt.js — UNIONX 25/08/2026
 * "Comprados juntos" propio de Lhotse. Reemplaza a la app Frequently Bought Together (CBB),
 * que en Simplit cuesta US$19,99/mes: Martin pidió el mismo patrón sin pagar (25/08/2026).
 *
 * El markup lo pinta el bloque custom-liquid; esto maneja los checkboxes, el total y el submit.
 * El producto principal SIEMPRE sigue la variante elegida arriba en la ficha (el <select> del
 * tema), no una variante fija: si no, el cliente elige talla M y el bundle agrega la S.
 */
(function () {
  'use strict';

  var CLP = function (centavos) {
    // Shopify entrega los precios en centavos. En CLP no hay decimales.
    var n = Math.round(centavos / 100);
    return '$' + n.toLocaleString('es-CL');
  };

  // Horizon 4.x ya NO escucha 'cart:update': su contador de la cabecera y el cajon del carro se
  // actualizan con el CartLinesUpdateEvent de '@shopify/events', que lleva una PROMESA que entrega
  // el carro. Sin esto el pack se agregaba bien pero el contador quedaba en 0 (auditoria Codex
  // 23/09/2026, reproducido el 24/09 en Lhotse: 3 productos en el carro y la burbuja oculta).
  // 🪤 NO usar la importacion dinamica de '@shopify/events' aca: el CDN de Shopify minifica los .js del tema con
  //    esbuild y lo reescribe como require("@shopify/events"), que no existe en el navegador; el
  //    catch se lo traga y parece que el codigo no corre (medido el 24/09). Por eso el import va
  //    dentro de un <script type="module"> creado en tiempo de ejecucion: un texto no se minifica.
  // En un tema sin '@shopify/events' (Icon, Dawn) el modulo falla al cargar y no pasa nada:
  // siguen sirviendo los CustomEvent de arriba.
  function conEventosShopify(cb) {
    if (window.__lhxEventosShopify) { cb(window.__lhxEventosShopify); return; }
    document.addEventListener('lhx:eventos-shopify', function () { cb(window.__lhxEventosShopify); }, { once: true });
    if (document.getElementById('lhx-eventos-shopify')) return;
    var s = document.createElement('script');
    s.type = 'module';
    s.id = 'lhx-eventos-shopify';
    s.textContent = "import * as m from '@shopify/events'; window.__lhxEventosShopify = m; document.dispatchEvent(new Event('lhx:eventos-shopify'));";
    document.head.appendChild(s);
  }

  function avisarCarroHorizon(items) {
    try {
      conEventosShopify(function (m) {
        if (!m || !m.CartLinesUpdateEvent) return;
        var diferido = m.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new m.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
          promise: diferido.promise,
        }));
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var armar = m.CartLinesUpdateEvent.createCartFromAjaxResponse;
            diferido.resolve({ cart: armar ? armar(c) : null, detail: { itemCount: c.item_count } });
          })
          .catch(function (e) { diferido.reject(e); });
      });
    } catch (e) {}
  }

  function init(caja) {
    if (!caja || caja.dataset.lhxListo) return;
    caja.dataset.lhxListo = '1';

    var filas = [].slice.call(caja.querySelectorAll('[data-lhx-fila]'));
    var totalEl = caja.querySelector('[data-lhx-total]');
    var antesEl = caja.querySelector('[data-lhx-antes]');
    var boton = caja.querySelector('[data-lhx-add]');
    var cuenta = caja.querySelector('[data-lhx-cuenta]');
    if (!filas.length || !boton) return;

    // La variante viva del producto principal: la que tenga el form de compra del tema.
    function idPrincipal() {
      var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (form && form.value) return form.value;
      var u = new URLSearchParams(location.search).get('variant');
      return u || filas[0].dataset.lhxVariante;
    }
    function precioPrincipal() {
      var id = idPrincipal();
      var op = filas[0].querySelector('option[value="' + id + '"]');
      if (op && op.dataset.precio) return parseInt(op.dataset.precio, 10);
      return parseInt(filas[0].dataset.lhxPrecio, 10);
    }

    function seleccion() {
      return filas.filter(function (f) {
        var c = f.querySelector('input[type="checkbox"]');
        return c && c.checked && !f.dataset.lhxAgotado;
      });
    }

    // 10% sobre los COMPLEMENTOS, nunca sobre el principal. Lo cobra de verdad el descuento
    // automatico "Comprados juntos -10%" de Shopify; esto solo tiene que mostrar lo mismo.
    var DESC = (parseFloat(caja.dataset.lhxDesc || '0') || 0) / 100;

    function recalcular() {
      var sel = seleccion();
      var total = 0, antes = 0;
      sel.forEach(function (f) {
        var esPrincipal = f.dataset.lhxPrincipal === '1';
        var p = esPrincipal ? precioPrincipal() : precioActual(f);
        antes += p;
        total += esPrincipal ? p : Math.round(p * (1 - DESC));
      });
      if (totalEl) totalEl.textContent = CLP(total);
      if (antesEl) {
        if (antes > total) { antesEl.textContent = CLP(antes); antesEl.hidden = false; }
        else antesEl.hidden = true;
      }
      if (cuenta) cuenta.textContent = sel.length;
      boton.disabled = sel.length === 0;
    }

    function precioActual(f) {
      var s = f.querySelector('select[data-lhx-variantes]');
      if (s && s.selectedOptions[0]) return parseInt(s.selectedOptions[0].dataset.precio, 10);
      return parseInt(f.dataset.lhxPrecio, 10);
    }
    function comparaActual(f) {
      var s = f.querySelector('select[data-lhx-variantes]');
      if (s && s.selectedOptions[0]) return parseInt(s.selectedOptions[0].dataset.compara || '0', 10);
      return parseInt(f.dataset.lhxCompara || '0', 10);
    }
    function varianteDe(f) {
      if (f.dataset.lhxPrincipal === '1') return idPrincipal();
      var s = f.querySelector('select[data-lhx-variantes]');
      if (s && s.value) return s.value;
      return f.dataset.lhxVariante;
    }

    caja.addEventListener('change', recalcular);
    // el variant picker del tema no emite 'change' en nuestro DOM: escuchamos el del documento
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) recalcular();
    });

    boton.addEventListener('click', function () {
      var sel = seleccion();
      if (!sel.length) return;
      var items = sel.map(function (f) {
        return { id: Number(varianteDe(f)), quantity: 1 };
      }).filter(function (i) { return i.id; });
      if (!items.length) return;

      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Agregando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.description) || 'no se pudo agregar');
          boton.textContent = 'Agregado \u2713';
          // que el tema refresque su contador/drawer. NO se redirige a /cart: sacar al cliente
          // de la ficha despues de agregar es perder la venta que sigue.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'lhx-fbt' } }));
          avisarCarroHorizon(items);
          var ver = caja.querySelector('[data-lhx-ver]');
          if (ver) ver.hidden = false;
          setTimeout(function () { boton.textContent = textoOriginal; boton.disabled = false; }, 2500);
        })
        .catch(function (err) {
          boton.textContent = textoOriginal;
          boton.disabled = false;
          var aviso = caja.querySelector('[data-lhx-error]');
          if (aviso) { aviso.textContent = 'No pudimos agregarlo: ' + err.message; aviso.hidden = false; }
        });
    });

    recalcular();
  }

  function construir() {
    [].slice.call(document.querySelectorAll('[data-lhx-fbt]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', construir);
  else construir();
  new MutationObserver(construir).observe(document.documentElement, { childList: true, subtree: true });
})();
